export enum DocumentReturnType {
    PDF = 0,
    PDF_LETTER = 1,
    PDF_4X6 = 2,
    PDF_4X8 = 3
}